module.exports = __webpack_public_path__ + "images/button_blank_0e423fdc3ff5693f3a29a73c9f808ba7.svg";